<template>
  <div>
    <drawer :drawerStatus.sync="status" @close="close" @submit="submit">
      <template slot="title">
        <slot name="info"></slot>
      </template>
      <div slot="content">
        <right-content
          @removeBanner="removeBanner"
          @openDialog="openDialog"
          @addBanner="addBanner"
          @saveBanner="save"
          @toggleData="toggleData"
          @uploadSucess="uploadSucess"
          :rightArr="list"
          :checkedArr="checkedArr"
          :len="maxLen"
          :submitText="submitText"
        />
      </div>
    </drawer>
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="800px"
      top="1vh"
      class="dt-dialog"
      @close="dialogConClose"
      @open="dialogConOpen"
    >
      <dialog-content
        :title="'跳转链接设置'"
        :tabNav="tabNav"
        ref="dialog-href"
        :checkedData="checkedData"
        @getCheckedData="getCheckedData"
      />
      <div slot="footer" class="dialog-footer">
        <el-button @click.stop="dialogConClose">取 消</el-button>
        <el-button type="primary" @click.stop="dialogConSubmit"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Drawer from "@/components/common/drawer.vue";
import DialogContent from "@/components/home/dialogContent.vue";
import RightContent from "@/components/home/rightContent.vue";
export default {
  props: {
    status: {
      type: Boolean,
      default: true,
    },
    list: {
      type: Array,
      default: () => [],
    },
    maxLen: {
      type: Number,
      default: 1,
    },
    submitText: {
      type: String,
      default: "",
    },
  },
  components: { Drawer, DialogContent, RightContent },
  data() {
    return {
      // maxLen: 6, // 最多三个
      checkedArr: [],
      dragging: null,
      dialogVisible: false,
      checkedData: {}, // 选中的数据 后期传递给后台
      tabNav: [
        { name: "文件夹", activeName: "folder" },
        { name: "模板", activeName: "image" },
      ],
      checkedKey: null, // 点击设置图片链接 获取第几个需要设置
    };
  },
  methods: {
    // 打开文件夹模板弹出框
    openDialog(key) {
      this.checkedKey = key;
      if (this.list[this.checkedKey].path_type == 1) {
        this.$set(
          this.checkedData,
          "id",
          this.list[this.checkedKey].directories_id
        );
        this.$set(this.checkedData, "activeType", "folder");
      } else {
        this.$set(
          this.checkedData,
          "id",
          this.list[this.checkedKey].template_id
        );
        this.$set(this.checkedData, "activeType", "image");
      }
      this.$nextTick(() => {
        this.dialogVisible = true;
      });
    },
    getCheckedData(checkedData, activeType) {
      // 获取选中的数据
      this.checkedData = { ...checkedData, activeType };
    },
    dialogConSubmit() {
      let data = this.list[this.checkedKey];
      if (!this.checkedData.id) {
        this.$alert("请选择跳转链接", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      if (this.checkedData.activeType === "folder") {
        let nameStr = this.$refs["dialog-href"].breadList
          .map((item) => item.name)
          .join("/");
        data.path_type = 1;
        data.directories_id = this.checkedData.id;
        data.template_id = 0;
        if (this.checkedData.name) {
          data.directories_name = nameStr
            ? nameStr + "/" + this.checkedData.name
            : this.checkedData.name;
        }
      } else {
        data.path_type = 2;
        data.directories_id = 0;
        if (this.checkedData.name) {
          data.template_name = this.checkedData.name;
        }
        data.template_id = this.checkedData.id;
      }
      this.$parent.editData(data, this.checkedKey);
      this.dialogVisible = false;
      let index = this.checkedArr.indexOf(this.checkedKey);
      let status = data.url && data.img_name;
      // if (this.submitText !== "轮播图") {
      //   status = data.url && data.img_name;
      // } else {
      //   status = data.url && data.img_name;
      // }
      if (index !== -1 && index !== undefined) {
        if (data.path_type === 1 && data.directories_id && status) {
          this.checkedArr.splice(index, 1);
        } else if (data.path_type === 2 && data.template_id && status) {
          this.checkedArr.splice(index, 1);
        }
      }
    },
    dialogConOpen() {
      this.$nextTick(() => {
        this.$refs["dialog-href"].handleClick();
      });
    },
    dialogConClose() {
      // 弹出框关闭， 需要
      this.checkedData = {};
      this.checkedKey = null;
      this.dialogVisible = false;
      this.$refs["dialog-href"].closeDialog(); // 关闭弹框  把数据初始化
    },
    close() {
      this.checkedArr = [];
      this.$emit("close", false);
    },
    addBanner() {
      if (this.list.length < this.maxLen) {
        this.list.push({
          name: `-`, // 轮播图默认传空
          img_name: "", // 模板分类传空
          path_type: 0, // 模板分类默认传0  1 文件 2 模板
          directories_id: "", // 目录ID字符串  必须path_type === 1  不是目录传空
          directories_name: "",
          template_id: "", // 必须path_type === 2   模板ID
          template_name: "",
          url: "", // 图片地址
          name_edit_status: false,
        });
      }
    },
    save() {
      // 保存轮播图 需要判断所有的属性是否为空， 为空则展示错误边框
      let list = this.list;
      let arr = [];
      if (list.length) {
        for (let i = 0; i < list.length; i++) {
          if (this.submitText === "轮播图") {
            if (!list[i].img_name || !list[i].url) {
              arr.push(i);
              continue;
            }
          } else {
            if (!list[i].name || !list[i].img_name || !list[i].url) {
              arr.push(i);
              continue;
            }
          }
          if (list[i].path_type === 0) {
            arr.push(i);
            continue;
          }
          if (list[i].path_type === 1 && list[i].directories_id === "") {
            arr.push(i);
            continue;
          }
          if (list[i].path_type === 2 && list[i].template_id === "") {
            arr.push(i);
            continue;
          }
        }
        if (arr.length) {
          this.checkedArr = arr;
          this.$emit("error", true);
        } else {
          // 请求保存接口
          this.$emit("error", false);
        }
      } else {
        this.$emit("error", true);
      }
    },
    removeBanner(key) {
      this.$confirm(
        `此操作将删除当前${this.submitText}，确认是否继续？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          const newItems = [...this.list];
          newItems.splice(key, 1);
          this.list = newItems;
          let index = this.checkedArr.indexOf(key);
          if (index !== -1) {
            this.checkedArr.splice(index, 1);
          }
          this.save();
          this.$emit("remove", newItems);
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消删除",
          // });
        });
    },
    toggleData(data) {
      // const newItems = [...this.list];
      // const src = newItems.indexOf(this.dragging);
      // const dst = newItems.indexOf(item);
      // newItems.splice(dst, 0, ...newItems.splice(src, 1));
      this.$emit("remove", data);
    },
    uploadSucess(res, key) {
      let data = this.list[key];
      data.url = res;
      let imageNameArr = res.split("/");
      data.img_name = imageNameArr[imageNameArr.length - 1] || imageNameArr[imageNameArr.length - 2];
      data.style = `background-image: url(${data.url})`;
      this.$parent.editData(data, key);
      if (this.checkedArr.indexOf(key) !== -1) {
        let index = this.checkedArr.indexOf(key);
        if (data.img_name && data.url) {
          if (data.path_type === 1 && data.directories_id) {
            this.checkedArr.splice(index, 1);
          } else if (data.path_type === 2 && data.template_id) {
            this.checkedArr.splice(index, 1);
          }
        }
      }
    },
  },
};
</script>
